import type { AuthUser } from '@type/auth';
import pdmScript from './pdmDashboard.raw.js?raw';

let loaded = false;

export function loadPdmEngine(): Promise<void> {
  if (loaded || window.__PDM_ENGINE_LOADED__) return Promise.resolve();
  loaded = true;

  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.textContent = pdmScript;
      script.onload = () => resolve();
      document.body.appendChild(script);
      window.__PDM_ENGINE_LOADED__ = true;
      resolve();
    } catch (e) {
      reject(e);
    }
  });
}

export function renderPdmDashboard(): void {
  if (typeof window.renderPdmDashboard === 'function') {
    window.renderPdmDashboard();
  }
}

export function syncPdmShell(): void {
  if (typeof window.syncPdmDashboardRoleShell === 'function') {
    window.syncPdmDashboardRoleShell();
  }
}

export function isPdmDashboardRole(user: AuthUser | null | undefined): boolean {
  return user?.role === 'dashboard';
}
